
import { computed, ref } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useChosenVariantDetailsStore } from '~/stores/useChosenVariantDetailsStore';
import useTracking from '~/composable/tracking/useTracking';
import useUtilities from '~/composable/useUtilities';

export default {
  setup() {
    const chosenVariantDetailsStore = useChosenVariantDetailsStore()
    const {
      chosenInstallment,
      chosenChannel,
      productDetails
    } = storeToRefs(chosenVariantDetailsStore)
    const { formatPrice } = useUtilities()
    const dialog = ref(false)
    const closeDialog = () => {
      dialog.value = false
    }

    const { track } = useTracking()

    const handleClick = () => track('minimumPrice', { productDetails, chosenInstallment, chosenChannel })

    return {
      formatPrice,
      track,
      handleClick,
      dialog,
      closeDialog,
      productDetails,
      chosenInstallment,
      chosenChannel,
      basePrice: computed(() => chosenChannel.value?.productBundlePrice?.basePrice),
      discount: computed(() => chosenChannel.value?.productBundlePrice?.discount),
      productWithSubscriptionPrice: computed(() => chosenChannel.value?.productBundlePrice?.productWithSubscriptionPrice),
      bundlePrice: computed(() => chosenChannel.value?.productBundlePrice?.bundlePrice),
      chosenInstallmentPeriod: computed(() => chosenInstallment.value?.months),
      bindingPeriodPayment: computed(() => chosenChannel.value?.productBundlePrice?.bindingPeriodPayment),
      minimumPrice: computed(() => chosenChannel.value?.productBundlePrice?.minimumPrice),
      chosenInstallmentAmount: computed(() => chosenInstallment.value?.amount),
      signUpFeeWithBinding: computed(() => chosenChannel.value?.subscription?.signUpFeeWithBinding)
    }
  }
}
